import ApiService from '@/common/api.service'

export default {
  getAnkenList () {
    return new Promise((resolve, reject) => {
      ApiService.query('/anken/list').then(response => {
        resolve(response)
      })
    })
  },
  getAnkenFilterList () {
    return new Promise((resolve, reject) => {
      ApiService.query('/anken/filterList').then(response => {
        resolve(response)
      })
    })
  }
}
